<template >
  <b-container fluid>
    <b-row>
      <b-col cols="12" v-if="(isAgregarContrib&&tipoPadron!='1.- Catastral')||!isAgregarContrib" class="mb-2">
        <b-input-group >
          <b-form-checkbox size="lg" switch v-model="contribuyenteActual.isBloquearCobro">Bloquear cobro</b-form-checkbox>
        </b-input-group>
      </b-col>
      <b-col cols="12" lg="12">
        <b-input-group  >
          <b-input-group-prepend style="cursor:pointer;" is-text><b-icon icon="ui-radios-grid" @click="llenarSiguienteClave" /></b-input-group-prepend>
          <b-form-input  type="text" placeholder="Clave/Cuenta" :state="$v.contribuyenteActual.clave.$invalid?false:null" v-model="contribuyenteActual.clave"></b-form-input>         
          <p class="error" v-if="!$v.contribuyenteActual.clave.minLength">La Clave no puede estar vacio</p>
          <p class="error" v-if="!$v.contribuyenteActual.clave.maxLength">La Clave es demasiado largo</p>
          <p class="error" v-if="!$v.contribuyenteActual.clave.required">Este campo es obligatorio.</p>
        </b-input-group>
      </b-col>
      <b-col cols="12" lg="12" v-if="tipoPadron=='1.- Catastral' || tipoPadron=='3.- Agua Potable'">
        <b-input-group  >
          <b-input-group-prepend is-text><b-icon icon="ui-radios-grid"></b-icon></b-input-group-prepend>
          <b-form-input  type="text" :placeholder="catalogoPadrones.vinculaCartografia?'Clave Catastral':'Clave/Cuenta Raíz'" v-model="contribuyenteActual.clave2"></b-form-input>         
        </b-input-group>
      </b-col>
      <b-col cols="12" lg="12" v-if="tipoPadron=='1.- Catastral'">
        <b-input-group  >
          <b-input-group-prepend is-text><b-icon icon="ui-radios-grid"></b-icon></b-input-group-prepend>
          <b-form-input  type="text" placeholder="Clave/Cuenta Adicional" v-model="contribuyenteActual.clave3"></b-form-input>         
        </b-input-group>
      </b-col>
      <b-col cols="12" lg="12" v-if="tipoPadron=='1.- Catastral' && catalogoPadrones.vinculaCartografia && isAgregarContrib">
        <b-form-textarea  v-model="contribuyenteActual.polPredio" max-rows="5"></b-form-textarea>
      </b-col>
    </b-row>  
    <b-row>
      <b-col cols="12" lg="12">
        <b-input-group >
          <b-input-group-prepend is-text><b-icon icon="person-fill"></b-icon></b-input-group-prepend>
          <b-form-input  placeholder="Nombre:" type="text" :state="$v.contribuyenteActual.nombre.$invalid?false:null" v-model="contribuyenteActual.nombre"></b-form-input>
          <b-form-input  placeholder="Apellido Paterno:" type="text"  v-model="contribuyenteActual.apellidoP" v-if="catalogoPadrones.mostrarApellidos"></b-form-input>
          <b-form-input  placeholder="Apellido Materno:" type="text"  v-model="contribuyenteActual.apellidoM" v-if="catalogoPadrones.mostrarApellidos"></b-form-input>
        </b-input-group>
      </b-col>
    </b-row>
    
    <b-row>
      <b-col cols="12" lg="12">
        <b-input-group >
          <b-input-group-prepend is-text><b-icon icon="house-fill" @click="isShowEditUbicacionDir=true" style="cursor:pointer;"></b-icon></b-input-group-prepend>
          <b-form-input placeholder="Dirección:" type="text" :state="$v.descripcion.$invalid?false:null" v-model="descripcion"></b-form-input>
          <p class="error" v-if="!$v.descripcion.minLength">La Dirección no puede estar vacio</p>
          <p class="error" v-if="!$v.descripcion.maxLength">La Dirección es demasiado largo</p>   
        </b-input-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" lg="8">
        <b-input-group >
          <b-input-group-prepend is-text><b-icon icon="card-heading"></b-icon></b-input-group-prepend>
          <b-form-input  placeholder="CURP:" type="text" :state="$v.contribuyenteActual.curp.$invalid?false:null" v-model="contribuyenteActual.curp"></b-form-input>
          <p class="error" v-if="!$v.contribuyenteActual.curp.minLength">El CURP es demasiado corto</p>
          <p class="error" v-if="!$v.contribuyenteActual.curp.maxLength">El CURP es demasiado largo</p>    
        </b-input-group>
      </b-col>
      <b-col cols="12" lg="4">
        <b-input-group >
          <b-input-group-prepend is-text><b-icon icon="grid-fill" style="cursor:pointer;" @click="isShowDatosFiscales=true"></b-icon></b-input-group-prepend>
          <b-form-input  placeholder="RFC:" type="text" :state="$v.contribuyenteActual.rfc.$invalid?false:null" v-model="contribuyenteActual.rfc"></b-form-input>
          <!-- <p class="error" v-if="!$v.contribuyenteActual.rfc.minLength">El RFC es demasiado corto</p>
          <p class="error" v-if="!$v.contribuyenteActual.rfc.maxLength">El RFC es demasiado largo</p>
          <p class="error" v-if="!$v.contribuyenteActual.rfc.required">Este campo es obligatorio.</p>      -->
        </b-input-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" lg="8">
        <b-input-group >
          <b-input-group-prepend is-text><b-icon icon="envelope-fill"></b-icon></b-input-group-prepend>
          <b-form-input  placeholder="Correo:" type="text" :state="$v.contribuyenteActual.correo.$invalid?false:null" v-model="contribuyenteActual.correo"></b-form-input>
          <p class="error" v-if="!$v.contribuyenteActual.correo.maxLength">El Correo es demasiado largo</p>      
        </b-input-group>
      </b-col>
      <b-col cols="12" lg="4">
        <b-input-group >
          <b-input-group-prepend is-text><b-icon icon="telephone-fill"></b-icon></b-input-group-prepend>
          <b-form-input  placeholder="Teléfono:" type="text" :state="$v.contribuyenteActual.telefono.$invalid?false:null" v-model="contribuyenteActual.telefono"></b-form-input>
          <p class="error" v-if="!$v.contribuyenteActual.telefono.minLength">El Telefono es demasiado corto</p>
          <p class="error" v-if="!$v.contribuyenteActual.telefono.maxLength">El Telefono es demasiado largo</p>    
        </b-input-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" lg="12">
        <b-input-group >
          <b-input-group-prepend is-text><b-icon icon="search"></b-icon></b-input-group-prepend>
          <b-form-textarea placeholder="Observaciones:" :state="$v.contribuyenteActual.obs.$invalid?false:null" v-model="contribuyenteActual.obs" max-rows="3"></b-form-textarea>
          <p class="error" v-if="!$v.contribuyenteActual.obs.maxLength">La observación es demasiado larga</p>  
        </b-input-group>
      </b-col>
    </b-row>
    <b-row v-if="!isAgregarContrib">
      <b-col cols="12" lg="6">
          <b-input-group >
          <b-input-group-prepend is-text><b-icon icon="file-text"></b-icon></b-input-group-prepend>
          <b-form-input  placeholder="No. de Actos:" type="text" :state="$v.contribuyenteActual.noActos.$invalid?false:null" v-model="contribuyenteActual.noActos"></b-form-input>
          <p class="error" v-if="!$v.contribuyenteActual.noActos.between">Este campo solo acepta valores entre 0-10</p>
          <p class="error" v-if="!$v.contribuyenteActual.noActos.required">Este campo es obligatorio.</p>    
        </b-input-group>
      </b-col>
      <b-col cols="12" lg="6">
        <b-form-checkbox size="lg" switch v-model="contribuyenteActual.isNotificado">Notificado</b-form-checkbox>
      </b-col>
    </b-row>
    <b-alert variant="danger" :show="msgErrorPadrones != ''">{{msgErrorPadrones}}</b-alert>
    <b-row align-h="center">
      <!-- <b-col cols="12" lg="4" v-if="!isAgregarContrib">
        <b-button block variant="danger" @click="guardarCambiosContrib">
          <b-spinner v-if="isGuardandoDatosContrib"></b-spinner>
          <strong v-if="isGuardandoDatosContrib"> GUARDANDO . . .</strong>
          <strong v-if="!isGuardandoDatosContrib"> GUARDAR CAMBIOS</strong>
        </b-button>
      </b-col> -->
      <b-col cols="12" lg="4" v-if="isAgregarContrib" class="mt-5">
        <!-- <b-button block variant="danger" @click="guardarNvoContrib">
          <b-spinner v-if="isGuardandoDatosContrib"></b-spinner>
          <strong v-if="isGuardandoDatosContrib"> GUARDANDO . . .</strong>
          <strong v-if="!isGuardandoDatosContrib"> GUARDAR CONTRIBUYENTE</strong>
        </b-button> -->

        <b-dropdown split variant="danger" @click="guardarNvoContrib">
          <template #button-content>
            <b-spinner v-if="isGuardandoDatosContrib"></b-spinner>
            <strong v-if="isGuardandoDatosContrib"> GUARDANDO . . .</strong>
            <strong v-if="!isGuardandoDatosContrib"> GUARDAR CONTRIBUYENTE</strong>
          </template>
          

          <b-dropdown-form>
            <b-form-group >
                <b-form-textarea
                  v-model="contribuyenteActual.fundamento"
                  placeholder="Fundamento ..."
                  rows="3"
                  max-rows="3"
                ></b-form-textarea>
            </b-form-group>
          </b-dropdown-form>
        </b-dropdown>
          
      </b-col>
    </b-row>

    <b-modal title="Ubicación" hide-footer v-model="isShowEditUbicacionDir" header-bg-variant="dark" header-text-variant="light">
      <b-row>
        <b-col cols="12">Vialidad<b-form-input size="sm" v-model="vialidad"></b-form-input></b-col>
        <b-col cols="6">No Exterior<b-form-input v-model="noExt"></b-form-input></b-col>
        <b-col cols="6">No Interior<b-form-input v-model="noInt"></b-form-input></b-col>
        <b-col cols="4">Manzana<b-form-input v-model="manzana"></b-form-input></b-col>
        <b-col cols="4">Lote<b-form-input v-model="lote"></b-form-input></b-col>    
        <b-col cols="4">Código Postal<b-form-input v-model="codigoPostal" ></b-form-input></b-col>    
        <b-col cols="6">Localidad<b-form-input size="sm" v-model="localidad"></b-form-input></b-col>
        <b-col cols="6">Colonia<b-form-input size="sm"   v-model="colonia"></b-form-input></b-col>
        <b-col cols="6">Municipio<b-form-input v-model="municipio"></b-form-input></b-col>
        <b-col cols="6">Estado<b-form-input v-model="estado"></b-form-input></b-col>        
        <b-col cols="6">Entre Calle<b-form-input v-model="entreCalle" ></b-form-input></b-col>
        <b-col cols="6">y Calle<b-form-input v-model="yCalle" ></b-form-input></b-col>
        <b-col cols="12">Denominación del Predio<b-form-input v-model="denominacion" ></b-form-input></b-col>
      </b-row>
      <b-row class="mt-4 mb-4" align="center">
        <b-col cols="12"><b-button pill variant="success" @click="usarUbiDirCompuesta">Continuar <b-icon icon="arrow-right-circle"/></b-button></b-col>
      </b-row>
    </b-modal>

    <b-modal  title="Datos Fiscales" v-model="isShowDatosFiscales" size="md" hide-footer  header-bg-variant="dark" header-text-variant="light">
      <b-row align-h="center">
        <b-col cols="11" md="10" lg="9" class="mt-3">
          <b>Tipo persona</b>
          <b-form-select v-model="contribuyenteActual.tipoPersona" :options="tiposPersona"></b-form-select>
        </b-col>
        <b-col cols="11" md="10" lg="9" class="mt-4 mb-4">
          <b>Tipo regimen fiscal</b>
          <b-form-select v-model="contribuyenteActual.tipoRegimenFiscal" :options="tiposRegimenFiscal"></b-form-select>
        </b-col>
      </b-row>      
    </b-modal>

  </b-container>
</template>

<script>
  import { mapState} from 'vuex';
  import axios from 'axios';
  import { minLength, maxLength, required, between } from 'vuelidate/lib/validators';
  import { server, checkAuth, getPostConfig, getGetConfig } from '@/axios-tools';

  export default {
    props: ['contribuyenteActual', 'isAgregarContrib', 'tipoPadron', 'accionPostAgregar'],
    computed: {
      ...mapState({
        token: state => state.login.token,
        catTipoPadronesAgregar: state => state.padrones.catalogoPadrones.tipoPadronesAgregar,
        catalogoPadrones: state => state.padrones.catalogoPadrones,
      }),
      descripcion:{
        get: function() {
          return this.contribuyenteActual.direccion.descripcion;
        },
        set: function(newValue) {
          this.contribuyenteActual.direccion.descripcion=newValue;
        },
      },
      vialidad:{
        get: function() {
          return this.contribuyenteActual.direccion.vialidad;
        },
        set: function(newValue) {
          this.contribuyenteActual.direccion.vialidad=newValue;
        },
      },
      noExt:{
        get: function() {
          return this.contribuyenteActual.direccion.noExt;
        },
        set: function(newValue) {
          this.contribuyenteActual.direccion.noExt=newValue;
        },
      },
      noInt:{
        get: function() {
          return this.contribuyenteActual.direccion.noInt;
        },
        set: function(newValue) {
          this.contribuyenteActual.direccion.noInt=newValue;
        },
      },
      manzana:{
        get: function() {
          return this.contribuyenteActual.direccion.manzana;
        },
        set: function(newValue) {
          this.contribuyenteActual.direccion.manzana=newValue;
        },
      },
      lote:{
        get: function() {
          return this.contribuyenteActual.direccion.lote;
        },
        set: function(newValue) {
          this.contribuyenteActual.direccion.lote=newValue;
        },
      },
      colonia:{
        get: function() {
          return this.contribuyenteActual.direccion.colonia;
        },
        set: function(newValue) {
          this.contribuyenteActual.direccion.colonia=newValue;
        },
      },
      localidad:{
        get: function() {
          return this.contribuyenteActual.direccion.localidad;
        },
        set: function(newValue) {
          this.contribuyenteActual.direccion.localidad=newValue;
        },
      },
      municipio:{
        get: function() {
          return this.contribuyenteActual.direccion.municipio;
        },
        set: function(newValue) {
          this.contribuyenteActual.direccion.municipio=newValue;
        },
      },
      estado:{
        get: function() {
          return this.contribuyenteActual.direccion.estado;
        },
        set: function(newValue) {
          this.contribuyenteActual.direccion.estado=newValue;
        },
      },
      codigoPostal:{
        get: function() {
          return this.contribuyenteActual.direccion.codigoPostal;
        },
        set: function(newValue) {
          this.contribuyenteActual.direccion.codigoPostal=newValue;
        },
      },
      entreCalle:{
        get: function() {
          return this.contribuyenteActual.direccion.entreCalle;
        },
        set: function(newValue) {
          this.contribuyenteActual.direccion.entreCalle=newValue;
        },
      },
      yCalle:{
        get: function() {
          return this.contribuyenteActual.direccion.yCalle;
        },
        set: function(newValue) {
          this.contribuyenteActual.direccion.yCalle=newValue;
        },
      },
      denominacion:{
        get: function() {
          return this.contribuyenteActual.direccion.denominacion;
        },
        set: function(newValue) {
          this.contribuyenteActual.direccion.denominacion=newValue;
        },
      }
    },
    components:{
    },
    data() {
      return {
        isGuardandoDatosContrib:false,
        msgErrorPadrones:"",
        isShowEditUbicacionDir:false,
        codeClient:this.$route.params.municipio,
        isShowDatosFiscales:false,
        tiposRegimenFiscal:[
          '601 - General de Ley Personas Morales',
          '603 - Personas Morales con Fines no Lucrativos',
          '605 - Sueldos y Salarios e Ingresos Asimilados a Salarios',
          '606 - Arrendamiento',
          '607 - Régimen de Enajenación o Adquisición de Bienes',
          '608 - Demás ingresos',
          '610 - Residentes en el Extranjero sin Establecimiento Permanente en México',
          '611 - Ingresos por Dividendos (socios y accionistas)',
          '612 - Personas Físicas con Actividades Empresariales y Profesionales',
          '614 - Ingresos por intereses',
          '615 - Régimen de los ingresos por obtención de premios',
          '616 - Sin obligaciones fiscales',
          '620 - Sociedades Cooperativas de Producción que optan por diferir sus ingresos',
          '621 - Incorporación Fiscal',
          '622 - Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras',
          '623 - Opcional para Grupos de Sociedades',
          '624 - Coordinados',
          '625 - Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas',
          '626 - Régimen Simplificado de Confianza',
          '000 - Sin Dato'
        ],
        tiposPersona:['FISICA', 'MORAL', 'SIN DATO']
      }
    },
    methods: {
      guardarNvoContrib(){
        if(!this.isGuardandoDatosContrib && !this.$v.$invalid && checkAuth(this.$router, this.$store)){
          this.isGuardandoDatosContrib=true;
          axios(
            getPostConfig(server.agregarContribuyente, this.contribuyenteActual, this.token, {tipoPadron:this.tipoPadron.substring(0,1)})
            ).then(res => {
              this.cleanFormulario();
              //res = "Se ha agregado el contribuyente";
              //this.msgErrorPadrones = res;
              this.$store.commit('updateOpcionFuncionPadron', 0);
              this.$store.commit("updateContribuyenteActual", res.data);

              this.$store.commit("updateTipoBusqueda", "Clave de contribuyente");
              this.$store.commit("updateClaveContribuyente", res.data.clave);

              this.accionPostAgregar(res.data);

              this.isGuardandoDatosContrib=false;
            }).catch(err => {
              this.isGuardandoDatosContrib=false;
              this.msgErrorPadrones = err.response.data;
            })
        }
      },
      llenarSiguienteClave(){
         var reto = this.contribuyenteActual.clave;
        if(this.tipoPadron=='3.- Agua Potable'){
         
          if(checkAuth(this.$router, this.$store)){
            axios(
              getGetConfig(server.obtenerSiguienteCuenta, null, this.token, {reto:reto})
              ).then(res => {
                this.contribuyenteActual.clave = res.data;
              }).catch(err => {
                this.msgErrorPadrones = err.response.data;
              })
          }
        }else if(this.tipoPadron=='1.- Catastral' ){
          if(checkAuth(this.$router, this.$store)){
            axios(
              getGetConfig(server.obtenerSiguientePredio, null, this.token, {reto:reto})
              ).then(res => {
                this.contribuyenteActual.clave = res.data;
              }).catch(err => {
                this.msgErrorPadrones = err.response.data;
              })
          }
        }
      },
      usarUbiDirCompuesta(){
        
        
        this.isShowEditUbicacionDir = false;
      },
      cleanFormulario(){
        this.contribuyenteActual={"clave":"",
                            "clave2":"",
                            "clave3":"",
                            "nombre":"",
                            "apellidoP":"",
                            "apellidoM":"",
                            "isBloquearCobro":"false",
                            "ubicacion":{
                              "descripcion":"",
                              "vialidad":"",
                              "noExt":"",
                              "noInt":"",
                              "manzana":"",
                              "lote":"",
                              "colonia":"",
                              "localidad":"",
                              "municipio":"",
                              "estado":"",
                              "codigoPostal":"",
                              "entreCalle":"",
                              "yCalle":"",
                              "denominacion:":"",
                            },
                            "direccion":{
                              "descripcion":"",
                              "vialidad":"",
                              "noExt":"",
                              "noInt":"",
                              "manzana":"",
                              "lote":"",
                              "colonia":"",
                              "localidad":"",
                              "municipio":"",
                              "estado":"",
                              "codigoPostal":"",
                              "entreCalle":"",
                              "yCalle":"",
                              "denominacion:":"",
                            },
                            "curp":"",
                            "rfc":"XAXX010101000",
                            "correo":"",
                            "telefono":"",
                            "obs":"",
                            "isNotificado":"false",
                            "noActos":"0",
                            "tipoPersona":"SIN DATO",
                            "tipoRegimenFiscal":"000 - SIN DATO"
                            }
      },
      // guardarCambiosContrib(){
      //   var datosContribuyente = {clave: this.contribuyenteActual.clave, correo: this.contribuyenteActual.correo, curp: this.contribuyenteActual.curp, direccion: this.contribuyenteActual.direccion, 
      //                             idContrib: this.contribuyenteActual.idContrib, isBloquearCobro: this.contribuyenteActual.isBloquearCobro, isNotificado: this.contribuyenteActual.isNotificado, 
      //                             noActos: this.contribuyenteActual.noActos, nombre: this.contribuyenteActual.nombre, obs: this.contribuyenteActual.obs, rfc: this.contribuyenteActual.rfc, 
      //                             telefono: this.contribuyenteActual.telefono, tipoContribuyente: this.contribuyenteActual.tipoContribuyente, ubicacion: this.contribuyenteActual.ubicacion, 
      //                             coordenada: this.contribuyenteActual.coordenada,
      //                             basesFiscales: this.contribuyenteActual.basesFiscales};
        
      //   if(!this.isGuardandoDatosContrib && !this.$v.contribuyenteActual.$invalid && checkAuth(this.$router, this.$store)){
      //     this.isGuardandoDatosContrib=true;
      //     axios(
      //       getPostConfig(server.editarContribuyente, datosContribuyente, this.token, {tipoPadron:this.contribuyenteActual.tipoContribuyente.substr(0, 1), clave:this.contribuyenteActual.clave})
      //       ).then(res => {
      //         this.$store.commit("updateContribuyenteActual", res.data);
      //         this.isGuardandoDatosContrib=false;
      //         alert("Se ha actualizado la información de contribuyente.");
      //       }).catch(err => {
      //         this.isGuardandoDatosContrib=false;
      //         handledError(err, server.editarContribuyente, this.$router, this.$store);
      //       })
      //   }
      // },
    },
    validations: {
      tipoPadron:{
        required
      },
      contribuyenteActual:{
        clave:{
          required,
          minLength: minLength(1),
          maxLength: maxLength(20)
        },
        nombre:{
          required,
          minLength: minLength(1),
          maxLength: maxLength(150)
        },
        curp:{
          minLength: minLength(18),
          maxLength: maxLength(18)
        },
        rfc:{
          required,
          minLength: minLength(12),
          maxLength: maxLength(13)
        },
        correo:{
          maxLength: maxLength(150)
        },
        telefono:{
          minLength: minLength(10),
          maxLength: maxLength(10)
        },
        obs:{
          maxLength: maxLength(500)
        },
        noActos:{
          between: between(0, 10),
          required
        }
      },
      descripcion:{
        required,
        minLength: minLength(1),
        maxLength: maxLength(300)
      },
      vialidad:{},
      noExt:{},
      noInt:{},
      manzana:{},
      lote:{},
      colonia:{},
      localidad:{},
      municipio:{},
      estado:{},
      codigoPostal:{},
      entreCalle:{},
      yCalle:{},
      denominacion:{}     
      ,
    }
  }
</script>
<style>
p.error    {color: red; }
</style>